function MusicCanvas({ selectedTrack }) {
  return (
    <canvas
      class="visualizer"
      id="music-canvas"
      width="640"
      height="100"
    ></canvas>
  );
}

export default MusicCanvas;
